import { FeatureCollection, Geometry } from 'geojson';
import type { CoreoProjectFeatures } from '../types';

export interface MapboxMapStyle {
  id: string;
  styleId: string;
  search: RegExp;
  label: string;
  icon: string;
}

export const mapboxMapStyles: MapboxMapStyle[] = [{
  id: 'streets-v12',
  styleId: 'streets',
  label: 'Streets',
  search: /^streets\-v/,
  icon: '/assets/imgs/mapbox-streets-preview.png'
}, {
  id: 'satellite-v9',
  styleId: 'satellite',
  label: 'Satellite',
  search: /^satellite\-v/,
  icon: '/assets/imgs/mapbox-satellite-preview.jpeg'
}, {
  id: 'satellite-streets-v12',
  styleId: 'satellite-streets',
  label: 'Sat/Streets',
  search: /^satellite\-streets\-v/,
  icon: '/assets/imgs/mapbox-satellite-streets-preview.jpeg'
}, {
  id: 'outdoors-v12',
  styleId: 'outdoors',
  label: 'Outdoors',
  search: /^outdoors\-v/,
  icon: '/assets/imgs/mapbox-outdoors-preview.png'
}, {
  id: 'bing',
  styleId: 'bing',
  label: 'Bing',
  search: /^bing/,
  icon: '/assets/imgs/bing-maps-preview.png'
}, {
  id: 'bluesky',
  styleId: 'bluesky',
  label: 'BlueSky',
  search: /^bluesky/,
  icon: '/assets/imgs/bluesky-preview.jpeg'
}];

/** Basemaps that need a plan feature. Any style not listed is always available. */
const PREMIUM_BASE_STYLE_FEATURES: Partial<Record<string, keyof CoreoProjectFeatures>> = {
  bing: 'bingMaps',
  bluesky: 'blueSkyMaps'
};

/**
 * Whether the project's plan locks this basemap. Missing features count as locked,
 * so a premium basemap never shows before the plan is known.
 */
export const isBaseStyleLocked = (features: Partial<CoreoProjectFeatures> | null | undefined, styleId: string): boolean => {
  const feature = PREMIUM_BASE_STYLE_FEATURES[styleId];
  return !!feature && !features?.[feature];
};

export type MapboxMapStyleId = typeof mapboxMapStyles[number]['id'];

export const matchMapboxStyleId = (styleId: string): MapboxMapStyleId => {
  for (const m of mapboxMapStyles) {
    if (m.search.test(styleId)) {
      return m.id;
    }
  }
  return null;
}

export const mapboxMapStyleUrl = (id: MapboxMapStyleId): string => `mapbox://styles/mapbox/${id}?optimize=true`;
export const mapboxMapStyleById = (id: MapboxMapStyleId): MapboxMapStyle => mapboxMapStyles.find(a => a.id === id);


export const emptyFeatureCollection = <T extends Geometry, P = { [name: string]: any }>(): FeatureCollection<T, P> => ({
  type: 'FeatureCollection',
  features: []
});

